var dataSet = [];

export function select_course_seller() {
    select2_course_id();
    create_datatable(dataSet, 'Mensalidade');

    $('#seller_course_id').change(function() {
        dataSet = [];
        var itemSelected = $(this).find(":selected").val();
        getCourse(itemSelected);
        calcDescount();
    });

    $('#seller_start_date').change(function() {
        var itemSelected = $('#seller_course_id').find(":selected").val();
        if (itemSelected) {
            dataSet = [];
            getCourse(itemSelected);
            calcDescount();
        }
    });
}

function create_datatable(dataSet, mensalidadeTitle) {
    $("#seller_payments").DataTable({
        language: {
            url: 'https://cdn.datatables.net/plug-ins/1.10.25/i18n/Portuguese-Brasil.json'
        },
        data: dataSet,
        columns: [
            { title: '' },
            { title: 'Mês' },
            { title: 'Vencimento' },
            { title: mensalidadeTitle },
            { title: 'Desconto' },
            { title: 'Valor Pago' },
            { title: 'Forma Pagamento' },
            { title: 'Parcelas' },
            { title: 'Pagamento' },
            { title: 'Observação' },
        ],
    });
}

function destroy_dataTable() {
    $("#seller_payments").DataTable().destroy();
}

function select2_course_id() {
    $('#seller_course_id').select2();
}

function getCourse(id) {
    $.get('/cursos/' + id, function(data) {
        fill_table_payments(data);
    });
}

function fill_table_payments(data) {
    destroy_dataTable();
    const meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
    const numero_meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    var initial_date = new Date(data.initial_date);
    var mes = initial_date.getMonth();
    var ano = initial_date.getFullYear();

    var today = toDay();

    function paymentFormSelect(value, disabled) {
        var disabledAttr = disabled ? " disabled" : "";
        return (
            "<select class='form-control' id='payment_form'" + disabledAttr + ">" +
            "<optgroup label='Externas'>" +
            "<option value='asaass'" + (value === "asaass" ? " selected" : "") + ">Asaas Geral</option>" +
            "<option value='asaas_parcelado'" + (value === "asaas_parcelado" ? " selected" : "") + ">Asaas Parcelado</option>" +
            "</optgroup>" +
            "<optgroup label='Internas'>" +
            "<option value='dinheiro'" + (value === "dinheiro" ? " selected" : "") + ">Dinheiro</option>" +
            "<option value='pix_nubank'" + (value === "pix_nubank" ? " selected" : "") + ">Pix - Nubank</option>" +
            "<option value='mercado_pago'" + (value === "mercado_pago" ? " selected" : "") + ">Mercado Pago</option>" +
            "<option value='maquininha'" + (value === "maquininha" ? " selected" : "") + ">Maquinha</option>" +
            "<option value='link_asaas'" + (value === "link_asaas" ? " selected" : "") + ">Link Asaas</option>" +
            "<option value='carreiras'" + (value === "carreiras" ? " selected" : "") + ">Carreiras</option>" +
            "</optgroup>" +
            "</select>"
        );
    }

    function paymentInstallmentSelect() {
        return (
            "<select class='form-control' style='display: none;' id='installment'>" +
            "<option value='1'>1x</option>" +
            "<option value='2'>2x</option>" +
            "<option value='3'>3x</option>" +
            "<option value='4'>4x</option>" +
            "<option value='5'>5x</option>" +
            "<option value='6'>6x</option>" +
            "<option value='7'>7x</option>" +
            "<option value='8'>8x</option>" +
            "<option value='9'>9x</option>" +
            "<option value='10'>10x</option>" +
            "</select>"
        );
    }

    const isAsaas = (data.asaas_payment === true || data.asaas_payment === 'true');
    const isRecurring = data.payment_form !== 'pagamento_unico';

    if (isRecurring) {
        const dueDay = parseInt(data.duo_date || 1, 10);
        const enrollmentDate = getEnrollmentDate();
        const periodDueDate = nextDueDate(enrollmentDate, dueDay);
        const useProrated = enrollmentDate.getTime() < periodDueDate.getTime();
        const fullValue = parseFloat(data.valor);
        const value = useProrated ? calcProratedValue(enrollmentDate, periodDueDate, fullValue, dueDay) : fullValue;
        const referenceDate = referenceMonthDate(enrollmentDate, dueDay);
        const displayMonth = referenceDate.getMonth();
        const displayYear = referenceDate.getFullYear();
        const defaultPaymentForm = isAsaas ? "asaass" : "dinheiro";

        for (let i = 0; i < 1; i++) {
            dataSet.push([
                i + 1, meses[displayMonth] + "/" + displayYear,
                "<input type='date' class='form-control' value='" + formatDate(enrollmentDate) + "' disabled/>",
                "<input type='number' class='form-control' id='value' value='" + value.toFixed(2) + "' disabled/>",
                "<input type='number' class='form-control' id='descount' value='0'/>",
                "<input type='number' class='form-control' id='total' value='" + value.toFixed(2) + "' disabled/>",
                paymentFormSelect(defaultPaymentForm, false),
                paymentInstallmentSelect(),
                "<input type='date' class='form-control' value='" + today + "'/>",
                "<input type='text' class='form-control' id='note'/>",
            ]);
        }
    } else if (isAsaas && data.payment_form === 'pagamento_unico') {
        const today = new Date();
        const mes = today.getMonth();
        const ano = today.getFullYear();
        
        for (let i = 0; i < 1; i++) {
            dataSet.push([
                i + 1, meses[mes] + "/" + ano, 
                "<input type='date' class='form-control' value='" + toDay() + "' disabled/>",
                "<input type='number' class='form-control' id='value' value='" + data.valor.toFixed(2) + "' disabled/>",
                "<input type='number' class='form-control' id='descount'/>",
                "<input type='number' id='total' class='form-control' value='" + data.valor.toFixed(2) + "' disabled />",
                paymentFormSelect("asaass", false),
                paymentInstallmentSelect(),
                "<input type='date' class='form-control' value='" + toDay() + "'/>",
                "<input type='text' class='form-control' id='note'/>",
            ]);
        }
    } else {
        for (let i = 0; i < 1; i++) {
            dataSet.push([
                i + 1, meses[mes] + "/" + ano, 
                "<input type='date' class='form-control' value='" + ano + "-" + numero_meses[mes] + "-" + data.duo_date + "' disabled/>",
                "<input type='number' class='form-control' id='value' value='" + data.valor.toFixed(2) + "' disabled/>",
                "<input type='number' class='form-control' id='descount'/>",
                "<input type='number' id='total' class='form-control' value='" + data.valor.toFixed(2) + "' disabled />",
                paymentFormSelect("dinheiro", false),
                paymentInstallmentSelect(),
                "<input type='date' class='form-control' value='" + today + "'/>",
                "<input type='text' class='form-control' id='note'/>",
            ]);
        }
    }

    const mensalidadeTitle = data.payment_form === 'pagamento_unico' ? 'Taxa Única' : 'Mensalidade';
    create_datatable(dataSet, mensalidadeTitle);
    showHideInstallments();
}

function toDay(){
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + dd;
    return today
  }

function parseDateInput(value) {
    if (!value) {
        return null;
    }
    var parts = value.split('-');
    if (parts.length !== 3) {
        return null;
    }
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1;
    var day = parseInt(parts[2], 10);
    var date = new Date(year, month, day);
    if (isNaN(date.getTime())) {
        return null;
    }
    date.setHours(0, 0, 0, 0);
    return date;
}

function getEnrollmentDate() {
    var input = $('#seller_start_date');
    if (!input.length) {
        var fallback = new Date();
        fallback.setHours(0, 0, 0, 0);
        return fallback;
    }
    var parsed = parseDateInput(input.val());
    if (parsed) {
        return parsed;
    }
    var fallback = new Date();
    fallback.setHours(0, 0, 0, 0);
    return fallback;
}

function referenceMonthDate(enrollmentDate, dueDay) {
    var periodStart = buildDate(enrollmentDate, dueDay);
    if (enrollmentDate.getTime() >= periodStart.getTime()) {
        return new Date(enrollmentDate.getFullYear(), enrollmentDate.getMonth(), 1);
    }
    var prev = addMonths(enrollmentDate, -1);
    return new Date(prev.getFullYear(), prev.getMonth(), 1);
}

function formatDate(date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}

function addMonths(date, months) {
    var d = new Date(date.getTime());
    d.setMonth(d.getMonth() + months);
    return d;
}

function buildDate(baseDate, day) {
    var year = baseDate.getFullYear();
    var month = baseDate.getMonth();
    var lastDay = new Date(year, month + 1, 0).getDate();
    var finalDay = Math.min(day, lastDay);
    return new Date(year, month, finalDay);
}

function nextDueDate(fromDate, day) {
    // Recebe a data atual e o dia do vencimento
    var candidate = buildDate(fromDate, day);
    if (candidate < fromDate) {
        // Usa o 1º dia do próximo mês para evitar overflow (ex.: 29/01 + 1 mês -> 01/03)
        var nextMonthBase = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 1);
        candidate = buildDate(nextMonthBase, day);
    }
    return candidate;
}

function calcProratedValue(enrollmentDate, dueDate, fullValue, day) {
    var enrollment = new Date(enrollmentDate.getFullYear(), enrollmentDate.getMonth(), enrollmentDate.getDate());
    var due = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
    var prevMonth = addMonths(due, -1);
    var periodStart = buildDate(prevMonth, day);
    var msInDay = 24 * 60 * 60 * 1000;
    var effectiveStart = enrollment > periodStart ? enrollment : periodStart;
    var daysInPeriod = Math.floor((due - periodStart) / msInDay);
    var daysRemaining = Math.floor((due - effectiveStart) / msInDay);
    
    if (daysInPeriod <= 0) {
        return fullValue;
    }
    var clampedDaysRemaining = Math.max(0, Math.min(daysRemaining, daysInPeriod));
    var value = fullValue * (clampedDaysRemaining / daysInPeriod);
    return Math.round(value * 100) / 100;
}

function calcDescount() {
    setTimeout(() => {
        $('#note').val('');
        $('#descount').val('0');
        // $('#descount').maskMoney({ allowNegative: false, thousands: '', decimal: '.', affixesStay: false, precision: 0 });
        $('#descount').focusout(function() {
            var descount = $('#descount').val();
            var value = $('#value').val();
            var value_total = (value - descount).toFixed(2);

            if (value_total < 0) {
                $("#seller_payments").notify("Atenção: Desconto não Permitido");
                $('#total').val(value);
                $('#descount').val(0);
            } else {
                $("#seller_payments").notify("Desconto Aplicado!", "success");
                $('#total').val(value_total);
            }
        });
    }, 500);
}

function showHideInstallments() {
    $(document).on('change', '#payment_form', function() {
        var paymentForm = $(this).val();
        if (paymentForm === 'asaas_parcelado') {
            $('#installment').show();
        } else {
            $('#installment').hide();
            $('#installment').val('1');
        }
    });
}
